import {
  FLOW_DEFAULT_ENABLED_HUMAN_TASK_TOOLS,
  FlowDurationUnits,
  type FlowHumanTaskBlockConfig,
  FlowHumanTaskBlockConfigSchema,
  FlowHumanTaskPresentationMode,
  FlowHumanTaskType,
} from 'flow-schema';

import { HumanTaskFormFields } from './FormFields';
import {
  getDefaultHumanTaskCustomSubtaskConfig,
  getDefaultHumanTaskWorkContextConfig,
} from './Steps/utils';
import { HumanTaskBlockDocumentationMarkdown } from './documentation';
import type { BlockConfigProps } from '../../types';

export const humanTaskConfig: BlockConfigProps<FlowHumanTaskBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'humanTask',
  defaultConfig: {
    taskType: FlowHumanTaskType.CustomSubtask,
    subtasks: [getDefaultHumanTaskCustomSubtaskConfig()],
    workContexts: [getDefaultHumanTaskWorkContextConfig()],
    expirationDuration: {
      value: '1',
      units: FlowDurationUnits.Days,
    },
    categoryId: null,
    presentationMode: FlowHumanTaskPresentationMode.Standard,
    tags: [],
    tools: {
      enabledTools: FLOW_DEFAULT_ENABLED_HUMAN_TASK_TOOLS,
      config: {
        clinicalQuestionAssistant: {},
        documentPacketGenerator: {},
        autofill: {},
      },
    },
  },
  configFields: {
    schema: FlowHumanTaskBlockConfigSchema,
    FormFields: HumanTaskFormFields,
  },
  documentationMarkdown: HumanTaskBlockDocumentationMarkdown,
};
